<div *ngIf="!simple" class="page-container footer">
  <div class="main-container">
    <div class="container footer-menu">
      <div class="content-box footer-menu-box">
        <ng-container *ngFor="let items of footerList">
          <div *ngIf="items.type !== 'Community'">
            <h3>{{ items.name }}</h3>
            <ul>
              <li *ngFor="let item of items.detail">
                <a
                  class="onact96-a"
                  *ngIf="getIsLink(item.url); else routerPage"
                  [href]="item.url"
                  [target]="item.isBlank ? '_blank' : '_self'"
                  >{{ item.title }}</a
                >
                <ng-template #routerPage>
                  <span class="onact96-not" (click)="jumpToPage(item.url, item.isBlank)">{{ item.title }}</span>
                </ng-template>
              </li>
            </ul>
          </div>
        </ng-container>
        <div class="footer-right">
          <div class="community">
            <p class="title">{{ 'community' | translate }}</p>
            <ul class="icon">
              <li *ngFor="let item of communityList.detail">
                <a class="onact96-a" [href]="item.url" [target]="item.isBlank ? '_blank' : '_self'">
                  <img src="{{ item.title }}" />
                </a>
              </li>
            </ul>
            <div class="language onact96" (click)="selectLang()">
              <div class="language-left">
                <i class="country countryIcon" [class]="countryClassName()"></i>
                <span class="countryLangName">{{ selectedLang?.name }}</span>
              </div>
              <img class="arrow" src="assets/images/datepicker/arrow.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container footer-sign">
      <div class="content-box">
        <p>{{ disclaimer }}</p>
        <div class="line2">
          <p>© 2006-{{ currentYear }} {{ 'brand_name' | translate }} | All Rights Reserved.</p>
          <div class="to-top onact96" (click)="layout.scrollToTopAnimation$.next(true)">
            <i class="icon-left-arrow"></i>
            <span>{{ 'home_to_top' | translate }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="container license-box">
      @if (currentConfig) {
        <div
          style="margin-right: 10px"
          [id]="'anj-' + currentConfig.id"
          [attr.data-anj-seal-id]="currentConfig.id"
          data-anj-image-size="48"
          data-anj-image-type="basic-small"
        ></div>
      }
      <!-- 牌照图片 -->
      <div class="license" *ngFor="let license of licensePic">
        <!-- 纯图片 -->
        <a
          class="onact96-a"
          [href]="license.url"
          [target]="license.isBlank ? '_blank' : '_self'"
          *ngIf="license.licenseType == 'Picture'"
        >
          <img class="org" [src]="license.image | preferWebp: true" />
        </a>
        <!-- ifrmae方式 -->
        <iframe [src]="license.resourceUrl" class="org" *ngIf="license.licenseType == 'Code'"></iframe>
      </div>
      <i class="icon-18plus"></i>
    </div>
    <div class="container game-18">
      <span>{{ 'g_c_b_a_p_r' | translate }}</span>
    </div>
  </div>
</div>
